var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.seller
    ? _c(
        "div",
        { attrs: { id: "update-register-info-page" } },
        [
          _c("div", { staticClass: "update-note" }, [
            _vm._v(
              "\n    ご利用者様の適正管理のため、ご登録情報の更新をお願いいたします。\n  "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box-steps" }, [
            _c("div", { staticClass: "step-name text-center m-b-sm" }, [
              _vm._v("STEP " + _vm._s(_vm.currentStep) + "/2")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentStep === 1,
                    expression: "currentStep === 1"
                  }
                ],
                staticClass: "step-one bg-white"
              },
              [
                _c("div", { staticClass: "item item-country" }, [
                  _c("div", { staticClass: "item-label" }, [_vm._v("国")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-content" }, [
                    _vm._v(_vm._s(_vm.seller.countryName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item item-corporate-kbn" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-content item-options" },
                    _vm._l(_vm.corporateKbnOptions, function(options) {
                      return _c(
                        "div",
                        {
                          key: options.id,
                          class: [
                            "option",
                            options.id === _vm.corporateKbn ? "selected" : ""
                          ],
                          on: {
                            click: function($event) {
                              _vm.corporateKbn = options.id
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "option-icon" }),
                          _c("div", { staticClass: "option-name" }, [
                            _vm._v(_vm._s(options.name))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-step-action" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-next-step",
                      attrs: {
                        type: "button",
                        disabled: _vm.disableNextStepOne
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.handleNextStepOne()
                        }
                      }
                    },
                    [_vm._v("次へ")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.currentStep === 2
              ? _c(
                  "div",
                  { staticClass: "step-two bg-white m-t-md" },
                  [
                    _vm.isJapanUser &&
                    _vm.corporateIds.includes(_vm.corporateKbn)
                      ? _c("japan-corporation-update-page", {
                          attrs: { seller: _vm.seller },
                          on: {
                            back: _vm.handlePrevStepOne,
                            handleSubmit: _vm.openUpdateConfirmModal
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isJapanUser &&
                    _vm.individualIds.includes(_vm.corporateKbn)
                      ? _c("japan-individual-update-page", {
                          attrs: { seller: _vm.seller },
                          on: {
                            back: _vm.handlePrevStepOne,
                            handleSubmit: _vm.openUpdateConfirmModal
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isJapanUser &&
                    _vm.corporateIds.includes(_vm.corporateKbn)
                      ? _c("china-corporation-update-page", {
                          attrs: { seller: _vm.seller },
                          on: {
                            back: _vm.handlePrevStepOne,
                            handleSubmit: _vm.openUpdateConfirmModal
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isJapanUser &&
                    _vm.individualIds.includes(_vm.corporateKbn)
                      ? _c("china-individual-update-page", {
                          attrs: { seller: _vm.seller },
                          on: {
                            back: _vm.handlePrevStepOne,
                            handleSubmit: _vm.openUpdateConfirmModal
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box-btn-skip-register-info m-t" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-skip-register-info",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.handleSkipRegisterInfo()
                  }
                }
              },
              [_vm._v("Skip")]
            )
          ]),
          _vm._v(" "),
          _vm.showUpdateConfirmModal
            ? _c("update-confirm-modal", {
                attrs: { message: "入力した内容で登録してもよろしいですか？" },
                on: {
                  close: _vm.closeUpdateConfirmModal,
                  confirm: _vm.handleUpdateRegisterInfo
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showUpdateCompletedModal
            ? _c("update-completed-modal", {
                on: { close: _vm.handleCloseCompletedModal }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-label" }, [
      _c("div", { staticClass: "label-title" }, [_vm._v("法人 / 個人")]),
      _vm._v(" "),
      _c("div", { staticClass: "label-required" }, [_vm._v("必須")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06c8f27e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c8f27e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/updateRegisterInfo/UpdateRegisterInfo.vue
// module id = null
// module chunks = 